const $items = $('.form__item--smart-placeholder');

export function toggleInputEmptiness($element) {
	if ($element.val() !== '') {
		$element
			.parents('.form__item--smart-placeholder')
			.addClass('is-not-empty');
	} else {
		$element
			.parents('.form__item--smart-placeholder')
			.removeClass('is-not-empty');
	}
}

$('.form__input--email').inputmask({
	mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]',
	greedy: false,
	showMaskOnHover: false,
	onBeforePaste: function (pastedValue, opts) {
		pastedValue = pastedValue.toLowerCase();
		return pastedValue.replace('mailto:', '');
	},
	definitions: {
		'*': {
			validator: '[0-9A-Za-zА-Яа-я!#$%&\'*+/=?^_\`{|}~\-]',
			cardinality: 1,
			casing: 'lower'
		}
	}
});

export function checkFields(elems) {
	elems.each(function (i, elem) {
		const $this = $(elem);

		if ($this.val() !== '') {
			$this
				.parent('.form__item')
				.addClass('is-not-empty');
		}
	});
}

function focusInput() {
	var $this = $(this);
	$this
		.parents('.form__item--smart-placeholder')
		.addClass('is-focused');
}

function blurInput() {
	var $this = $(this);
	$this.val(String($this.val()).trim());
	$this
		.parents('.form__item--smart-placeholder')
		.removeClass('is-focused');
	toggleInputEmptiness($this);
}

$items.find('.form__input, .form__textarea')
	.on('focusout', blurInput)
	.on('focus', focusInput);


$items.each(function () {
	$(this).parents('form').eq(0).on('reset', function () {
		$(this).find('.form__item--smart-placeholder .form__input, .form__item--smart-placeholder .form__textarea')
			.each(function () {
				toggleInputEmptiness($(this));
			});
	});
});



// WEBPACK FOOTER //
// ./temp/components/form/index.js